import { render, staticRenderFns } from "./SAPAPIDiagnostics.vue?vue&type=template&id=0b56af39&scoped=true"
import script from "./SAPAPIDiagnostics.vue?vue&type=script&lang=js"
export * from "./SAPAPIDiagnostics.vue?vue&type=script&lang=js"
import style0 from "./SAPAPIDiagnostics.vue?vue&type=style&index=0&id=0b56af39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b56af39",
  null
  
)

export default component.exports